import qs from 'qs';
import { createWithEqualityFn as create } from 'zustand/traditional';

interface TaskDrawerStateStore {
    selectedTaskId: number | null;
    setSelectedTaskId: (taskId: number | null) => void;
    isDrawerOpen: boolean;
    setIsDrawerOpen: (isOpen: boolean) => void;
    collapsedGroups: string[];
    setCollapsedGroups: (groups: string[]) => void;
    goToTask: (taskId: number) => void;
}

const useTaskDrawerState = create<TaskDrawerStateStore>(set => {
    let params = qs.parse(location.search, { ignoreQueryPrefix: true });
    const initialTaskId = params.taskId && Number(params.taskId) ? Number(params.taskId) : null;
    const initialOpen = typeof params.openTasks !== 'undefined';

    return {
        selectedTaskId: initialTaskId,
        setSelectedTaskId: selectedTaskId => {
            let params = qs.parse(location.search, { ignoreQueryPrefix: true });
            if (selectedTaskId !== null) {
                params.taskId = selectedTaskId.toString();
            } else {
                params.taskId = undefined;
            }

            set({ selectedTaskId });
            history.pushState({}, '', `${location.pathname}?${qs.stringify(params)}`);
        },
        isDrawerOpen: initialOpen || !!initialTaskId,
        setIsDrawerOpen: isDrawerOpen => set({ isDrawerOpen }),
        collapsedGroups: [],
        setCollapsedGroups: collapsedGroups => set({ collapsedGroups }),
        goToTask: taskId => {
            set({ selectedTaskId: taskId, isDrawerOpen: true });
        },
    };
});

export { useTaskDrawerState };
export type { TaskDrawerStateStore };
